import { render, staticRenderFns } from "./Machinery.vue?vue&type=template&id=1994bcb1&scoped=true&"
import script from "./Machinery.vue?vue&type=script&lang=js&"
export * from "./Machinery.vue?vue&type=script&lang=js&"
import style0 from "./Machinery.vue?vue&type=style&index=0&id=1994bcb1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1994bcb1",
  null
  
)

export default component.exports